module.exports = __webpack_public_path__ + "img/66578a5.jpg";